const Roles = {
  TOKEN: '__deeptrueAuth',
  ROLES: {
    DEEPTRUE_ADMIN: 1,
    USER: 2,
  },
  ORGANIZATION_ROLE: {
    ADMIN: 1,
    MEMBER: 2,
    POWER: 3,
    GUEST: 4,
  },
};

export default Roles;

export enum OrganizationRole {
  ADMIN = 1,
  MEMBER = 2,
  POWER = 3,
  GUEST = 4,
}

export const getOrganizationRoleNme = (role: 1 | 2 | 3 | 4) => {
  return Object.keys(Roles.ORGANIZATION_ROLE)
    .find(
      // @ts-ignore
      (key) => Roles.ORGANIZATION_ROLE[key] === role
    )
    ?.toLowerCase();
};
